export default function arrayIdInjector(array, id) {
  // eslint-disable-next-line no-param-reassign
  array.id = id;
  return array;
}
